// extracted by mini-css-extract-plugin
module.exports = {"modal":"DownloadModal_modal__1YoiE","titleRow":"DownloadModal_titleRow__SAAg8","downloadButton":"DownloadModal_downloadButton__2g3D0"};